import { render } from "./wSelectTree.vue?vue&type=template&id=c0cd8b20&ts=true"
import script from "./wSelectTree.vue?vue&type=script&lang=ts"
export * from "./wSelectTree.vue?vue&type=script&lang=ts"

import exportComponent from "E:\\Work\\Sales point\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__